import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import Grid from "@mui/material/Grid/Grid"
import Typography from "@mui/material/Typography"

const useCases = [
  {
    title: "Wouldn't you rather?",
    body: `
Who is in charge of your life? Who makes the decisions? Where does the buck stop? For most of us, the story goes one of two ways: 

1) "I'm in charge. This is my life, and I'm captain of it.
  Or else, 
2) "Not me. It's their world, and I'm just living in it."

Maybe in some areas you feel the first way; in others, the second. Heck, maybe in some seasons you feel more one way than the other. Maybe at work you follow orders, but at home you're king of the castle.

Or maybe you're the big honcho at the office, while your spouse runs the show nights and weekends.

But that's not the whole story, is it? You're a three-dimensional human being, and you're involved in more than just these two scenes.

What about at church? Sure, the pastor gives sermons, but isn't it a community of volunteers? What about game night? Maybe whoever hosts gets their "house rules," but next week it'll be someone else and, besides, they're not really the boss of you.

Or are they?
`,
  },
  {
    title: "Who needs bullies?",
    body: `
We all have that one friend or colleague who expects to get their way. And sometimes it's easier to let them than to fight them. Maybe they're the loudest in the room. The most shameless. The quickest to the answer. Heck, maybe their ideas are *really that good* most of the time.

Or, was it just that *one time*, and now you're all defaulting to their opinion? Maybe you're defaulting to lots of easy answers: same place as last time. Same thing as last time. Same restaurant, same game, same strategy, same options. Hey, you've got a good thing going; why risk it by opening things up to debate? A debate you're pretty sure will last *forever*, reignite *old flamewars*, and in the end that same bully will get their way because, hey, *you're* not the bully in the group right? But someone has to be, right?
    `,
  },
  {
    title: "Why not do our best?",
    body: `
What if... no one had to be the bully? What if debates didn't last forever? What if nobody had to get hurt; nobody had to back down. What if nobody had to shoot anybody down or—on the flip side—duck (or hold our tongues in the first place)!

What if we could try things—reasonable things; good ideas. The *best* ideas from the people around us. What if? What if the next time our group hit a fork in the road, we took it? 

What if we could get... not just what's championed by the loudest voice in the room, or even the highest paid, but something we might actually want? Something we might actually care about?

Wouldn't you rather?
    `,
  },
]

export function UseCaseList() {
  return (
    <Grid sx={{ mt: { xs: 1, sm: 5 } }} container spacing={2}>
      {useCases.map((useCase: { title: string; body: string }) => (
        <Grid item xs={12} sm={4}>
          <Card sx={{ height: "100%" }}>
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                {useCase.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {useCase.body}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}
